import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';

import { TextField } from 'components';
import { Alert, Button, SubmitRow } from 'elements';

import validate from './validate';

class LoginForm extends Component {
	static propTypes = {
		onSubmit: PropTypes.func,
	};

	render() {
		const { error, handleSubmit } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				{error && <Alert message={error} type="error" />}
				<Field
					name="username"
					label="Username"
					htmlFor="username"
					component={TextField}
				/>
				<Field
					name="password"
					label="Password"
					htmlType="password"
					htmlFor="password"
					component={TextField}
					extra={
						<Link to="/forgot-password">
							I've forgotten my password
						</Link>
					}
				/>
				{this.props.showTOTPInput && (
					<Field
						name="totp"
						label="OTP Code"
						htmlFor="totp"
						component={TextField}
					/>
				)}
				<SubmitRow>
					<Button htmlType="submit" type="primary" wide>
						Enter
					</Button>
				</SubmitRow>
			</form>
		);
	}
}

export default reduxForm({
	form: 'login',
	validate,
})(LoginForm);



// WEBPACK FOOTER //
// ./src/smart-components/login-form/index.js